import { Link } from "react-router-dom";

type Props = {
  item: {
    id: number;
    name: string;
    price: number;
    stock: number;
    product_images: { image_path: string }[];
  };
};

const ProductCard: React.FC<Props> = ({ item }) => {
  const image = item.product_images?.[0]?.image_path || "/images/placeholder.png";

  return (
    <div
      className="
          bg-white
          rounded-2xl
          border
          shadow-sm
          hover:shadow-lg
          transition
          overflow-hidden
          min-w-0
        ">
      {/* IMAGE */}
      <div className="aspect-[4/3] bg-gray-100">
        <img src={image} alt={item.name} className="w-full h-full object-cover" />
      </div>

      {/* CONTENT */}
      <div className="p-4">
        <Link to={`https://belaskasih.com/product/${item?.id}`} target="_blank">
          <h3 className="text-sm font-semibold text-gray-900 line-clamp-2 mb-1">{item.name}</h3>

          <p className="text-red-500 font-bold text-sm mb-1">Rp {item.price.toLocaleString("id-ID")}</p>

          <p className="text-xs text-gray-500">{item.stock} Tersisa</p>
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;
